import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import ThemeProvider from "@/components/ThemeProvider";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import RoleRoute, { defaultRoute } from "@/components/RoleRoute";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Pending from "@/pages/Pending";
import FirstLogin from "@/pages/FirstLogin";
import CollectorForm from "@/pages/CollectorForm";
import FacilityDashboard from "@/pages/FacilityDashboard";
import ProcessingForm from "@/pages/ProcessingForm";
import ShipmentForm from "@/pages/ShipmentForm";
import AdminDashboard from "@/pages/AdminDashboard";
import ViewerDashboard from "@/pages/ViewerDashboard";
import SuperadminDashboard from "@/pages/SuperadminDashboard";
import Profile from "@/pages/Profile";
import ConfirmPasswordChange from "@/pages/ConfirmPasswordChange";

function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-[#3F3F3F]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={defaultRoute(user.role, user.status)} replace />;
}

function PendingGate() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-[#3F3F3F]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin" || user.status === "Active") {
    return <Navigate to={defaultRoute(user.role)} replace />;
  }
  return <Pending />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/pending" element={<PendingGate />} />
          <Route path="/first-login" element={<FirstLogin />} />
          <Route path="/confirm-password-change" element={<ConfirmPasswordChange />} />
          <Route
            path="/collect"
            element={
              <RoleRoute roles={["collector"]}>
                <CollectorForm />
              </RoleRoute>
            }
          />
          <Route
            path="/facility"
            element={
              <RoleRoute roles={["facility"]}>
                <FacilityDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="/facility/processing"
            element={
              <RoleRoute roles={["facility"]}>
                <ProcessingForm />
              </RoleRoute>
            }
          />
          <Route
            path="/facility/shipment"
            element={
              <RoleRoute roles={["facility"]}>
                <ShipmentForm />
              </RoleRoute>
            }
          />
          <Route
            path="/facility/shipment/:id/edit"
            element={
              <RoleRoute roles={["facility"]}>
                <ShipmentForm />
              </RoleRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <RoleRoute roles={["admin"]}>
                <AdminDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="/viewer"
            element={
              <RoleRoute roles={["viewer"]}>
                <ViewerDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="/superadmin"
            element={
              <RoleRoute roles={["superadmin"]}>
                <SuperadminDashboard />
              </RoleRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <RoleRoute roles={["collector", "facility", "admin", "viewer", "superadmin"]}>
                <Profile />
              </RoleRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
